import type {
  VisitorProfile,
  VisitorProfileField,
} from "@/lib/graphql/queries/generated/profile.generated";

/**
 * Dashboard preview: the operator's DRAFT custom profile fields (not saved yet, so the BE does not
 * return them) appended after the session profile's fields, EMPTY and READ-ONLY (`pinned`). Keys the
 * BE profile already returns win and are skipped. Returns the same object when nothing is added.
 */
export function withPreviewFields(
  profile: VisitorProfile,
  extra: readonly { key: string; label: string }[],
): VisitorProfile {
  const seen = new Set(profile.fields.map((f) => f.key));
  const added: VisitorProfileField[] = [];
  for (const f of extra) {
    if (seen.has(f.key)) continue;
    seen.add(f.key);
    added.push({
      __typename: "VisitorProfileField",
      key: f.key,
      label: f.label || f.key,
      type: "STRING",
      required: false,
      pinned: true,
      options: null,
      value: "",
    } as VisitorProfileField);
  }
  return added.length === 0 ? profile : { ...profile, fields: [...profile.fields, ...added] };
}
